import cn from 'classnames';
import React from 'react';
import {useSelector} from 'react-redux';

import domService from '../../../services/domService';
import tncService from '../../../services/tncService';
import {setTncPopupCode} from '../../../state/ducks/tnc';
import {makeSelectTncLegals, makeSelectTncLegalsByType} from '../../../state/selectors/consumer';
import {dispatch} from '../../../state/store';
import styles from './TermsOfUseDescription.module.scss';

const TermsOfUseDescription = (props) => {
    const {innerHtml, className, tncType, testId} = props;
    const textClassName = cn(className, 'whitespace-pre-line');
    const legals = useSelector(makeSelectTncLegals());
    const tncLegals = useSelector(makeSelectTncLegalsByType(tncType));
    const tncLinkClass = styles.TncLink;

    const onReadButtonClick = (e) => {
        const {target} = e;
        const tncCode = tncService.getTncCodeFromTarget(target, tncLinkClass);

        if (tncCode) {
            dispatch(setTncPopupCode(tncCode));
        }
    };

    const textParsed = tncService.getParsedDescription(innerHtml, tncLinkClass, legals, tncLegals);

    const onKeyPress = (e) => domService.handleBtnKeyPress(e, onReadButtonClick);

    return (
        <p
            className={textClassName}
            dangerouslySetInnerHTML={{__html: textParsed}}
            onClick={onReadButtonClick}
            onKeyPress={onKeyPress}
            data-testid={testId}
        />
    );
};

export default TermsOfUseDescription;
